// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"660":"acfc66ec","911":"c6ea8fd7"}[chunkId] || chunkId) + "." + {"191":"30249aaea9632853","660":"b888cab30ab515a4","729":"f5478212cc762096","911":"2632e2bba6002826","952":"11c867eb71e7e0ba"}[chunkId] + ".js";
};